import {
    StrollerAllReviewsPhotosState,
    StrollersAllReviewsPhotosState,
    initialStrollerAllReviewsPhotosState,
    initialStrollersAllReviewsPhotosState,
} from "@/mk2/apps/strollers/containers/StrollerAllReviewsPhotos/StrollerAllReviewsPhotos.reducers";
import { AppState } from "@/mk2/reducers";

export const getStrollerAllReviewsPhotosPageState = (
    state: AppState,
    strollerSlug: string,
): StrollerAllReviewsPhotosState =>
    getStrollerAllReviewsPhotosPagesState(state).pages[strollerSlug] ||
    initialStrollerAllReviewsPhotosState;

export const getStrollerAllReviewsPhotosPagesState = (
    state: AppState,
): StrollersAllReviewsPhotosState =>
    state.containers.strollers.strollersAllReviewsPhotos || initialStrollersAllReviewsPhotosState;
